// extracted by mini-css-extract-plugin
export default {"wrapper":"xD-z","addressLine":"yD-z","fullName":"zD-z"};